import { CoreIcon } from '../core-icon';
import questionCircleFillSVG from '../../assets/icons/question-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const QuestionCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={questionCircleFillSVG} {...props} />;
};
